import type { SiteCmsMediaQuota } from '@shared/types/entities';

export function cmsBytes(value: number): string {
  if (value <= 0) return '0 octet';
  if (value < 1024) return `${value} octets`;
  if (value < 1024 * 1024) return `${(value / 1024).toLocaleString('fr-FR', { maximumFractionDigits: 1 })} Ko`;
  return `${(value / 1024 / 1024).toLocaleString('fr-FR', { maximumFractionDigits: 2 })} Mo`;
}
export function cmsQuotaStatus(quota: SiteCmsMediaQuota): 'available' | 'warning' | 'full' {
  if (quota.count >= quota.maxCount || quota.usedBytes >= quota.maxBytes) return 'full';
  return quota.count >= quota.maxCount * 0.8 || quota.usedBytes >= quota.maxBytes * 0.8 ? 'warning' : 'available';
}
/** Predict PDFs exactly. Image inputs are optimized before storage: never reject
 * a large source just because its unoptimized bytes exceed the remaining space. */
export function cmsStorageFileIssue(
  kind: 'images' | 'documents',
  file: Pick<File, 'size' | 'name' | 'type'> | null,
  quota?: SiteCmsMediaQuota,
): string | null {
  if (!file || !quota) return null;
  if (!file.size) return 'Ce fichier est vide.';
  if (quota.count >= quota.maxCount)
    return `Limite de ${quota.maxCount} ${kind === 'images' ? 'images' : 'documents'} atteinte.`;
  if (quota.usedBytes >= quota.maxBytes)
    return 'Espace de stockage épuisé. Retirez un fichier inutilisé avant un nouvel import.';
  if (file.size > quota.maxUploadBytes)
    return `Ce fichier dépasse la limite de ${cmsBytes(quota.maxUploadBytes)} par import.`;
  if (kind === 'documents') {
    if ((file.type && file.type !== 'application/pdf') || (!file.type && !/\.pdf$/i.test(file.name)))
      return 'Choisissez un document PDF.';
    const remaining = Math.max(0, quota.maxBytes - quota.usedBytes);
    if (file.size > remaining)
      return `Ce PDF de ${cmsBytes(file.size)} dépasse les ${cmsBytes(remaining)} encore disponibles.`;
  }
  return null;
}
